module.exports = __webpack_public_path__ + "public/Icons/wheelchair.svg?e0702fa4";